export enum Entity {
  PRODUCT = "PRODUCT",
  SUPPLIER = "SUPPLIER",
  BARCODE = "BARCODE",
  PRODUCT_TYPE = "PRODUCT_TYPE",
  BLOB_STORAGE = "BLOB_STORAGE",
  DOCUMENT = "DOCUMENT",
  DEALER = "DEALER",
  DEALER_DEALER_MASTER_DEALER = "DEALER_DEALER_MASTER_DEALER",
  SETTING = "SETTING",
  EMAIL = "EMAIL",
  TEMPLATE = "TEMPLATE",
  ORDER = "ORDER",
  INVENTORY_COUNTS = "INVENTORY_COUNTS",
  FedEx = "FedEx",
  PRODUCT_AUDIT = "PRODUCT_AUDIT"
}
